
__webpack_require__.remotesLoadingData = { chunkMapping: {"847":["9746"]}, moduleIdToRemoteDataMapping: {"9746":{"shareScope":"default","name":"./RemoteComponent","externalModuleId":2258,"remoteName":"remote"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
